// extracted by mini-css-extract-plugin
export default {"ns_link":"S1_DeviceCheckConfirm_ns_link__hKlby","disable_btn":"S1_DeviceCheckConfirm_disable_btn__G8bNU"};